// Copyright (c) 2021, Comsearch, Inc., All rights reserved

import { pathCartDrawerContext } from 'components/PathCart/contexts'
import { useContext } from 'react'

/**
 @typedef pathCartDrawerState
 @type {array}
 @property {boolean} 0 - pathCartIsActive
 @property {Function} 1 - togglePathCartIsActive
 */

/**
 * Returns the value of the pathCartDrawerContext
 * @returns {pathCartDrawerState}
 */

const usePathCartDrawerContext = () => (
  useContext(pathCartDrawerContext)
)

export default usePathCartDrawerContext
